import ReactDOM from 'react-dom';
import LoadingIcon from './LoadingIcon';

let container: HTMLDivElement | null = null;

const Spinner = {
    show: () => {
        if (!container) {
            container = document.createElement('div');
            document.body.appendChild(container);
            ReactDOM.render(<LoadingIcon />, container);
        }
    },
    hide: () => {
        if (container) {
            ReactDOM.unmountComponentAtNode(container);
            document.body.removeChild(container);
            container = null;
        }
    },
};

export default Spinner;
